import React, { useEffect } from 'react';
import { StepSection } from './index';
import { ONBOARDING_STEPS } from '../../../utils/constants';
import { FormValues, OnboardingStep } from '../../../types';
import { trackEvent, QuestionAnsweredFromPage, trackSectionLoadedEvent } from '../../../utils/mixpanel';
import { Button } from '../../borrower/components';

interface QuestionaryContentProps {
  selectedIndex: number;
  setSelectedIndex: (index: number, options?: { force?: boolean }) => void;
  values: FormValues;
  setValue: (key: string, value: string | number) => void;
  setBottomValue: (value: number) => void;
  children: React.ReactNode;
  isBrokerMode: boolean;
  steps?: OnboardingStep[];
}

export const QuestionaryContent: React.FC<QuestionaryContentProps> = (props) => {
  const {
    selectedIndex,
    setSelectedIndex,
    values,
    setValue,
    setBottomValue,
    children,
    isBrokerMode,
    steps: externalSteps,
  } = props;

  useEffect(() => {
    trackSectionLoadedEvent('Background Questionary');
  }, []);

  const handleSelect = (key: string, value: string | number): void => {
    setValue(key, value);
    trackEvent(QuestionAnsweredFromPage(key, value));
  };

  const steps = externalSteps || ONBOARDING_STEPS;

  return (
    <React.Fragment>
      {steps.map((step, i) => (
        <StepSection
          key={step.text}
          step={step}
          isSelected={selectedIndex === i}
          value={values[step.text] ? String(values[step.text]) : undefined}
          stepIndex={i}
          onSelect={(value) => {
            handleSelect(step.text, value);
            // Do not auto-advance on state selection; require explicit Continue
            if (step.text !== 'Where is the property located?') {
              setSelectedIndex(i + 1);
            }
          }}
          setBottomValue={setBottomValue}
          isBrokerMode={isBrokerMode}
          customMarkup={
            step.text === 'Where is the property located?'
              ? (
                <div className='step-actions' style={{ marginTop: 16 }}>
                  <Button
                    outlined={false}
                    isLoading={false}
                    disabled={!values[step.text]}
                    onClick={() => setSelectedIndex(i + 1)}
                  >
                    Continue
                  </Button>
                </div>
              )
              : (i === 5) ? <div className="space"></div> : null
          }
        />
      ))}
      {children}
    </React.Fragment>
  );
};
